import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const STORAGE_KEY = "norma_install_app_popup_hidden";
const VIDEO_URL = "https://www.youtube.com/embed/b2Eym_ftxP8?autoplay=1&rel=0";

export default function InstallAppPopup({ enabled }) {
  const location = useLocation();
  const enabledOnHome = enabled && location.pathname === "/";
  const [open, setOpen] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    if (!enabledOnHome) {
      setOpen(false);
      return;
    }
    try {
      setOpen(window.localStorage.getItem(STORAGE_KEY) !== "1");
    } catch {
      setOpen(true);
    }
  }, [enabledOnHome]);

  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => {
      if (event.key === "Escape") closePopup();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  });

  const closePopup = () => {
    if (dontShowAgain) {
      try {
        window.localStorage.setItem(STORAGE_KEY, "1");
      } catch {
        // La chiusura deve funzionare anche se lo storage non e disponibile.
      }
    }
    setOpen(false);
    setShowVideo(false);
  };

  if (!enabledOnHome || !open) return null;

  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center bg-slate-950/65 p-4 backdrop-blur-sm" role="dialog" aria-modal="true" aria-labelledby="install-app-popup-title">
      <div className="relative w-full max-w-lg overflow-hidden rounded-3xl bg-white shadow-2xl">
        <button type="button" onClick={closePopup} className="absolute right-3 top-3 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-white/95 text-slate-600 shadow-md transition hover:bg-slate-100 hover:text-slate-900 focus:outline-none focus:ring-2 focus:ring-emerald-500" aria-label="Chiudi" title="Chiudi">
          <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" /></svg>
        </button>
        {showVideo ? (
          <div className="bg-slate-950 px-4 pb-4 pt-16 sm:px-6 sm:pb-6">
            <div className="mx-auto aspect-[9/16] max-h-[70vh] overflow-hidden rounded-2xl bg-black">
              <iframe className="h-full w-full" src={VIDEO_URL} title="Come installare Norma sul cellulare" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen />
            </div>
          </div>
        ) : (
          <div className="px-6 pb-7 pt-16 text-center sm:px-10 sm:pb-9">
            <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-emerald-100 text-emerald-700">
              <svg viewBox="0 0 24 24" className="h-9 w-9" aria-hidden="true"><rect x="6.5" y="2.5" width="11" height="19" rx="2.5" fill="none" stroke="currentColor" strokeWidth="1.8" /><path d="M10 18.5h4M12 6v7m0 0 3-3m-3 3-3-3" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>
            </div>
            <h2 id="install-app-popup-title" className="text-2xl font-bold text-slate-900">Hai già installato Norma sul tuo cellulare?</h2>
            <button type="button" onClick={() => setShowVideo(true)} className="mt-4 inline-flex items-center justify-center rounded-xl bg-emerald-600 px-6 py-3 font-semibold text-white shadow-sm transition hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2">Clicca qui per vedere come fare</button>
          </div>
        )}
        <label className="flex cursor-pointer items-center justify-center gap-3 border-t border-slate-200 bg-slate-50 px-5 py-4 text-sm font-medium text-slate-700">
          <input type="checkbox" checked={dontShowAgain} onChange={(event) => setDontShowAgain(event.target.checked)} className="h-5 w-5 rounded border-slate-300 text-emerald-600 focus:ring-emerald-500" />
          Non mostrarlo più
        </label>
      </div>
    </div>
  );
}
